export const environment = {
  production: true,
  passwordMinLength: 8,
  useEmulators: false,
  firebase: {
    apiKey: 'AIzaSyCuDs9PUtEDCuclVRDuIWA3l_GTaSH1Xz4',
    authDomain: 'van-kit.firebaseapp.com',
    projectId: 'van-kit',
    storageBucket: 'van-kit.firebasestorage.app',
    messagingSenderId: '854699446344',
    appId: '1:854699446344:web:e70e1f5e28661ef72b887d',
    measurementId: 'G-YPWQYD4WLY',
  },
  socialLogin: {
    google: {
      webClientId:
        // this is the web client from the google cloud console under 'Web client  (auto created by Google Service)'
        '854699446344-unckkrkna2chshjo5tp6smnk50slo66j.apps.googleusercontent.com',
    },
  },
};
